
<template>
  <div>
    <sp-select
      :class="govError ? 'has-error input' : ''"
      theme="team"
      :required="true"
      v-model="selectGovernorate"
      :options="governorate"
      :selected="selectedgovernorate"
      name="country"
      id="governorate"
      placeholder="Gouvernorat"
      :label="$t('company.governorate')"
      class="mb-5"
    ></sp-select>

    <sp-select
      :class="delError ? 'has-error input' : ''"
      v-if="delegation.length>0 || selecteddelegation"
      theme="team"
      :required="true"
      :label="$t('company.delegation')"
      v-model="selectDelegation"
      :options="delegation"
      :selected="selecteddelegation"
      name="city"
      id="delegation"
      placeholder="delegation"
      class="mb-5"
    ></sp-select>

    <sp-input
      v-if="codePostal"
      theme="team"
      :required="true"
      :label="$t('Code Postal')"
      v-model="codePostal"
      :value="codePostal"
      name="postal_code"
      id="codePostal"
      placeholder="codePostal"
      class="mb-5"
      :disabled="selecteddelegation ? true : false"
    ></sp-input>
  </div>
</template>

<script>
import SelectVue from "./Select.vue";
import { dynamicList } from "@/common/codePostalData";
import Input from "../spKit/Input.vue";
export default {
  name: "sp-code-postal-list",
  components: {
    "sp-select": SelectVue,
    "sp-input": Input,
  },
  props: {
    selectedgovernorate: {
      required: false,
      type: String,
      default: null
    },
    govError: {
      required: false,
      type: Boolean,
      default: false
    },
    delError: {
      required: false,
      type: Boolean,
      default: false
    },
    selecteddelegation: {
      required: false,
      type: String,
      default: null
    },
    selectedcodePostal: {
      required: false,
      type: [String, Number],
      default: null
    },
    edited: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    this.updateCodePostal();
    this.updateDelegation();
  },
  watch: {
    selectedcodePostal() {
      this.updateCodePostal();
    },

    selectGovernorate(val) {
      if (val && this.edited == false) {
        let keysSectors = this.data[val];
        this.delegation = [];
        let i = 0;
        Object.keys(keysSectors).forEach((key, value) => {
          this.delegation.push({ name: key, value: i });
          i++;
        });
        this.$emit("select-change", ["governorate", val]);
      }
      //this.$emit("edit-change-deleg",false);
    },
    selectDelegation(val) {
      this.codePostal = null;
      this.codePostal = this.data[this.selectGovernorate ? this.selectedgovernorate : this.selectedgovernorate][val][0];
      this.$emit("select-change", ["delegation", val]);
      this.$emit("code-postal", ["codePostal", this.codePostal]);
      this.updateDelegation();
    },
    selectedgovernorate(val) {
      this.selectGovernorate = val;
      let keysSectors = this.data[val];
      this.delegation = [];
      let i = 0;
      Object.keys(keysSectors).forEach((key) => {
        this.delegation.push({ name: key, value: i });
        i++;
      });
    }
  },
  methods: {
    updateCodePostal() {
      if (this.selectedcodePostal) {
        this.codePostal = this.selectedcodePostal;
      }
    },
    updateDelegation() {
      if (this.selecteddelegation) {
        let keysSectors = this.data[this.selectedgovernorate];
        if(this.delegation.length<=0) {
          this.delegation = [];
          let i = 0;
          Object.keys(keysSectors).forEach((key, value) => {
            this.delegation.push({ name: key, value: i });
            i++;
          });
        }
      }
    },
  },
  data() {
    return {
      selectGovernorate: null,
      selectDelegation: null,
      selectCodePostal: null,
      delegation: [],
      codePostal: null,
      governorate: [
        { name: "TUNIS", value: "1" },
        { name: "ARIANA", value: "2" },
        { name: "BEN AROUS", value: "3" },
        { name: "MANNOUBA", value: "4" },
        { name: "NABEUL", value: "5" },
        { name: "ZAGHOUAN", value: "6" },
        { name: "BIZERTE", value: "7" },
        { name: "BEJA", value: "8" },
        { name: "JENDOUBA", value: "9" },
        { name: "LE KEF", value: "10" },
        { name: "SILIANA", value: "11" },
        { name: "KAIROUAN", value: "12" },
        { name: "KASSERINE", value: "13" },
        { name: "SIDI BOUZID", value: "14" },
        { name: "SOUSSE", value: "15" },
        { name: "MONASTIR", value: "16" },
        { name: "MAHDIA", value: "17" },
        { name: "SFAX", value: "18" },
        { name: "GAFSA", value: "19" },
        { name: "TOZEUR", value: "20" },
        { name: "KEBILI", value: "21" },
        { name: "GABES", value: "22" },
        { name: "MEDENINE", value: "23" },
        { name: "TATAOUINE", value: "24" }
      ],
      data: dynamicList().data,
      form: {
        country: null,
        city: null,
        postal_code: null,
      },
    };
  }
};
</script>

<style>
</style>
